
const boldMap = {
    'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲', 'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶',
    'j': '𝗷', 'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼', 'p': '𝗽', 'q': '𝗾', 'r': '𝗿',
    's': '𝘀', 't': '𝘁', 'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆', 'z': '𝘇',
    'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗', 'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜',
    'J': '𝗝', 'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡', 'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥',
    'S': '𝗦', 'T': '𝗧', 'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫', 'Y': '𝗬', 'Z': '𝗭',
    '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', '7': '𝟳', '8': '𝟴', '9': '𝟵',
    'á': '𝗮́', 'é': '𝗲́', 'í': '𝗶́', 'ó': '𝗼́', 'ú': '𝘂́', 'ý': '𝘆́', 'č': '𝗰̌', 'ď': '𝗱̌', 'ě': '𝗲̌', 'ň': '𝗻̌', 'ř': '𝗿̌', 'š': '𝘀̌', 'ť': '𝘁̌', 'ů': '𝘂̊', 'ž': '𝘇̌',
    'Á': '𝗔́', 'É': '𝗘́', 'Í': '𝗜́', 'Ó': '𝗢́', 'Ú': '𝗨́', 'Ý': '𝗬́', 'Č': '𝗖̌', 'Ď': '𝗗̌', 'Ě': '𝗘̌', 'Ň': '𝗡̌', 'Ř': '𝗥̌', 'Š': '𝗦̌', 'Ť': '𝗧̌', 'Ů': '𝗨̊', 'Ž': '𝗭̌',
    'à': '𝗮̀', 'è': '𝗲̀', 'ì': '𝗶̀', 'ò': '𝗼̀', 'ù': '𝘂̀', 'ỳ': '𝘆̀', 'â': '𝗮̂', 'ê': '𝗲̂', 'î': '𝗶̂', 'ô': '𝗼̂', 'û': '𝘂̂', 'ŷ': '𝘆̂', 'ä': '𝗮̈', 'ë': '𝗲̈', 'ï': '𝗶̈', 'ö': '𝗼̈', 'ü': '𝘂̈', 'ÿ': '𝘆̈', 'ã': '𝗮̃', 'ẽ': '𝗲̃', 'ĩ': '𝗶̃', 'õ': '𝗼̃', 'ũ': '𝘂̃', 'ỹ': '𝘆̃', 'å': '𝗮̊', 'ø': '𝗼̊', 'æ': '𝗮𝗲', 'œ': '𝗼𝗲', 'ß': '𝘀𝘀', 'ç': '𝗰̧', 'ñ': '𝗻̃', 'Å': '𝗔̊', 'Ø': '𝗢̊', 'Æ': '𝗔𝗘', 'Œ': '𝗢𝗘', 'Ç': '𝗖̧', 'Ñ': '𝗡̃',
};

const fromBoldToBoldItalicMap = {
    '𝗮': '𝙖', '𝗯': '𝙗', '𝗰': '𝙘', '𝗱': '𝙙', '𝗲': '𝙚', '𝗳': '𝙛', '𝗴': '𝙜', '𝗵': '𝙝', '𝗶': '𝙞',
    '𝗷': '𝙟', '𝗸': '𝙠', '𝗹': '𝙡', '𝗺': '𝙢', '𝗻': '𝙣', '𝗼': '𝙤', '𝗽': '𝙥', '𝗾': '𝙦', '𝗿': '𝙧',
    '𝘀': '𝙨', '𝘁': '𝙩', '𝘂': '𝙪', '𝘃': '𝙫', '𝘄': '𝙬', '𝘅': '𝙭', '𝘆': '𝙮', '𝘇': '𝙯',
    '𝗔': '𝘼', '𝗕': '𝘽', '𝗖': '𝘾', '𝗗': '𝘿', '𝗘': '𝙀', '𝗙': '𝙁', '𝗚': '𝙂', '𝗛': '𝙃', '𝗜': '𝙄',
    '𝗝': '𝙅', '𝗞': '𝙆', '𝗟': '𝙇', '𝗠': '𝙈', '𝗡': '𝙉', '𝗢': '𝙊', '𝗣': '𝙋', '𝗤': '𝙌', '𝗥': '𝙍',
    '𝗦': '𝙎', '𝗧': '𝙏', '𝗨': '𝙐', '𝗩': '𝙑', '𝗪': '𝙒', '𝗫': '𝙓', '𝗬': '𝙔', '𝗭': '𝙕',
    '𝟬': '0', '𝟭': '1', '𝟮': '2', '𝟯': '3', '𝟰': '4', '𝟱': '5', '𝟲': '6', '𝟳': '7', '𝟴': '8', '𝟵': '9',
    '𝗮́': 'á', '𝗲́': 'é', '𝗶́': 'í', '𝗼́': 'ó', '𝘂́': 'ú', '𝘆́': 'ý', '𝗰̌': 'č', '𝗱̌': 'ď', '𝗲̌': 'ě', '𝗻̌': 'ň', '𝗿̌': 'ř', '𝘀̌': 'š', '𝘁̌': 'ť', '𝘂̊': 'ů', '𝘇̌': 'ž',
    '𝗔́': 'Á', '𝗘́': 'É', '𝗜́': 'Í', '𝗢́': 'Ó', '𝗨́': 'Ú', '𝗬́': 'Ý', '𝗖̌': 'Č', '𝗗̌': 'Ď', '𝗘̌': 'Ě', '𝗡̌': 'Ň', '𝗥̌': 'Ř', '𝗦̌': 'Š', '𝗧̌': 'Ť', '𝗨̊': 'Ů', '𝗭̌': 'Ž',
    '𝗮̀': 'à', '𝗲̀': 'è', '𝗶̀': 'ì', '𝗼̀': 'ò', '𝘂̀': 'ù', '𝘆̀': 'ỳ', '𝗮̂': 'â', '𝗲̂': 'ê', '𝗶̂': 'î', '𝗼̂': 'ô', '𝘂̂': 'û', '𝘆̂': 'ŷ', '𝗮̈': 'ä', '𝗲̈': 'ë', '𝗶̈': 'ï', '𝗼̈': 'ö', '𝘂̈': 'ü', '𝘆̈': 'ÿ', '𝗮̃': 'ã', '𝗲̃': 'ẽ', '𝗶̃': 'ĩ', '𝗼̃': 'õ', '𝘂̃': 'ũ', '𝘆̃': 'ỹ', '𝗮̊': 'å', '𝗼̊': 'ø', '𝗮𝗲': 'æ', '𝗼𝗲': 'œ', '𝘀𝘀': 'ß', '𝗰̧': 'ç', '𝗻̃': 'ñ', '𝗔̊': 'Å', '𝗢̊': 'Ø', '𝗔𝗘': 'Æ', '𝗢𝗘': 'Œ', '𝘾̧': 'Ç', '𝗡̃': 'Ñ',
};

const fromItalicBoldToRegularBoldMap = {
    '𝙖': '𝗮', '𝙗': '𝗯', '𝙘': '𝗰', '𝙙': '𝗱', '𝙚': '𝗲', '𝙛': '𝗳', '𝙜': '𝗴', '𝙝': '𝗵', '𝙞': '𝗶',
    '𝙟': '𝗷', '𝙠': '𝗸', '𝙡': '𝗹', '𝙢': '𝗺', '𝙣': '𝗻', '𝙤': '𝗼', '𝙥': '𝗽', '𝙦': '𝗾', '𝙧': '𝗿',
    '𝙨': '𝘀', '𝙩': '𝘁', '𝙪': '𝘂', '𝙫': '𝘃', '𝙬': '𝘄', '𝙭': '𝘅', '𝙮': '𝘆', '𝙯': '𝘇',
    '𝘼': '𝗔', '𝘽': '𝗕', '𝘾': '𝗖', '𝘿': '𝗗', '𝙀': '𝗘', '𝙁': '𝗙', '𝙂': '𝗚', '𝙃': '𝗛', '𝙄': '𝗜',
    '𝙅': '𝗝', '𝙆': '𝗞', '𝙇': '𝗟', '𝙈': '𝗠', '𝙉': '𝗡', '𝙊': '𝗢', '𝙋': '𝗣', '𝙌': '𝗤', '𝙍': '𝗥',
    '𝙎': '𝗦', '𝙏': '𝗧', '𝙐': '𝗨', '𝙑': '𝗩', '𝙒': '𝗪', '𝙓': '𝗫', '𝙔': '𝗬', '𝙕': '𝗭',
    '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', '7': '𝟳', '8': '𝟴', '9': '𝟵',
    'á': '𝗮́', 'é': '𝗲́', 'í': '𝗶́', 'ó': '𝗼́', 'ú': '𝘂́', 'ý': '𝘆́', 'č': '𝗰̌', 'ď': '𝗱̌', 'ě': '𝗲̌', 'ň': '𝗻̌', 'ř': '𝗿̌', 'š': '𝘀̌', 'ť': '𝘁̌', 'ů': '𝘂̊', 'ž': '𝘇̌',
    'Á': '𝗔́', 'É': '𝗘́', 'Í': '𝗜́', 'Ó': '𝗢́', 'Ú': '𝗨́', 'Ý': '𝗬́', 'Č': '𝗖̌', 'Ď': '𝗗̌', 'Ě': '𝗘̌', 'Ň': '𝗡̌', 'Ř': '𝗥̌', 'Š': '𝗦̌', 'Ť': '𝗧̌', 'Ů': '𝗨̊', 'Ž': '𝗭̌',
    'à': '𝗮̀', 'è': '𝗲̀', 'ì': '𝗶̀', 'ò': '𝗼̀', 'ù': '𝘂̀', 'ỳ': '𝘆̀', 'â': '𝗮̂', 'ê': '𝗲̂', 'î': '𝗶̂', 'ô': '𝗼̂', 'û': '𝘂̂', 'ŷ': '𝘆̂', 'ä': '𝗮̈', 'ë': '𝗲̈', 'ï': '𝗶̈', 'ö': '𝗼̈', 'ü': '𝘂̈', 'ÿ': '𝘆̈', 'ã': '𝗮̃', 'ẽ': '𝗲̃', 'ĩ': '𝗶̃', 'õ': '𝗼̃', 'ũ': '𝘂̃', 'ỹ': '𝘆̃', 'å': '𝗮̊', 'ø': '𝗼̊', 'æ': '𝗮𝗲', 'œ': '𝗼𝗲', 'ß': '𝘀𝘀', 'ç': '𝗰̧', 'ñ': '𝗻̃', 'Å': '𝗔̊', 'Ø': '𝗢̊', 'Æ': '𝗔𝗘', 'Œ': '𝗢𝗘', 'Ç': '𝗖̧', 'Ñ': '𝗡̃',
};


// convert for italicmap all characters to italic including all languages and accents
const italicMap = {
    'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦', 'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪',
    'j': '𝘫', 'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰', 'p': '𝘱', 'q': '𝘲', 'r': '𝘳',
    's': '𝘴', 't': '𝘵', 'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺', 'z': '𝘻',
    'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋', 'E': '𝘌', 'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐',
    'J': '𝘑', 'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕', 'O': '𝘖', 'P': '𝘗', 'Q': '𝘘', 'R': '𝘙',
    'S': '𝘚', 'T': '𝘛', 'U': '𝘜', 'V': '𝘝', 'W': '𝘞', 'X': '𝘟', 'Y': '𝘠', 'Z': '𝘡',
    '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', '7': '𝟳', '8': '𝟴', '9': '𝟵',
    'á': '𝘢́', 'é': '𝘦́', 'í': '𝘪́', 'ó': '𝘰́', 'ú': '𝘶́', 'ý': '𝘺́', 'č': '𝘤̌', 'ď': '𝘥̌', 'ě': '𝘦̌', 'ň': '𝘯̌', 'ř': '𝘳̌', 'š': '𝘴̌', 'ť': '𝘵̌', 'ů': '𝘶̊', 'ž': '𝘻̌',
    'Á': '𝘈́', 'É': '𝘌́', 'Í': '𝘐́', 'Ó': '𝘖́', 'Ú': '𝘜́', 'Ý': '𝘠́', 'Č': '𝘊̌', 'Ď': '𝘋̌', 'Ě': '𝘌̌', 'Ň': '𝘕̌', 'Ř': '𝘙̌', 'Š': '𝘚̌', 'Ť': '𝘛̌', 'Ů': '𝘜̊', 'Ž': '𝘡̌',
    'à': '𝘢̀', 'è': '𝘦̀', 'ì': '𝘪̀', 'ò': '𝘰̀', 'ù': '𝘶̀', 'ỳ': '𝘺̀', 'â': '𝘢̂', 'ê': '𝘦̂', 'î': '𝘪̂', 'ô': '𝘰̂', 'û': '𝘶̂', 'ŷ': '𝘺̂', 'ä': '𝘢̈', 'ë': '𝘦̈', 'ï': '𝘪̈', 'ö': '𝘰̈', 'ü': '𝘶̈', 'ÿ': '𝘺̈', 'ã': '𝘢̃', 'ẽ': '𝘦̃', 'ĩ': '𝘪̃', 'õ': '𝘰̃', 'ũ': '𝘶̃', 'ỹ': '𝘺̃', 'å': '𝘢̊', 'ø': '𝘰̊', 'æ': '𝘢𝘦', 'œ': '𝘰𝘦', 'ß': '𝘴𝘴', 'ç': '𝘤̧', 'ñ': '𝘯̃', 'Å': '𝘈̊', 'Ø': '𝘖̊', 'Æ': '𝘈𝘌', 'Œ': '𝘖𝘌', 'Ç': '𝘊̧', 'Ñ': '𝘕̃',
};

const boldItalicMap = {
    'a': '𝙖', 'b': '𝙗', 'c': '𝙘', 'd': '𝙙', 'e': '𝙚', 'f': '𝙛', 'g': '𝙜', 'h': '𝙝', 'i': '𝙞',
    'j': '𝙟', 'k': '𝙠', 'l': '𝙡', 'm': '𝙢', 'n': '𝙣', 'o': '𝙤', 'p': '𝙥', 'q': '𝙦', 'r': '𝙧',
    's': '𝙨', 't': '𝙩', 'u': '𝙪', 'v': '𝙫', 'w': '𝙬', 'x': '𝙭', 'y': '𝙮', 'z': '𝙯',
    'A': '𝘼', 'B': '𝘽', 'C': '𝘾', 'D': '𝘿', 'E': '𝙀', 'F': '𝙁', 'G': '𝙂', 'H': '𝙃', 'I': '𝙄',
    'J': '𝙅', 'K': '𝙆', 'L': '𝙇', 'M': '𝙈', 'N': '𝙉', 'O': '𝙊', 'P': '𝙋', 'Q': '𝙌', 'R': '𝙍',
    'S': '𝙎', 'T': '𝙏', 'U': '𝙐', 'V': '𝙑', 'W': '𝙒', 'X': '𝙓', 'Y': '𝙔', 'Z': '𝙕',
    '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', '7': '𝟳', '8': '𝟴', '9': '𝟵',
    'á': '𝙖́', 'é': '𝙚́', 'í': '𝙞́', 'ó': '𝙤́', 'ú': '𝙪́', 'ý': '𝙮́', 'č': '𝙘̌', 'ď': '𝙙̌', 'ě': '𝙚̌', 'ň': '𝙣̌', 'ř': '𝙧̌', 'š': '𝙨̌', 'ť': '𝙩̌', 'ů': '𝙪̊', 'ž': '𝙯̌',
    'Á': '𝘼́', 'É': '𝙀́', 'Í': '𝙄́', 'Ó': '𝙊́', 'Ú': '𝙐́', 'Ý': '𝙔́', 'Č': '𝘾̌', 'Ď': '𝘿̌', 'Ě': '𝙀̌', 'Ň': '𝙉̌', 'Ř': '𝙍̌', 'Š': '𝙎̌', 'Ť': '𝙏̌', 'Ů': '𝙐̊', 'Ž': '𝙕̌',
    'à': '𝙖̀', 'è': '𝙚̀', 'ì': '𝙞̀', 'ò': '𝙤̀', 'ù': '𝙪̀', 'ỳ': '𝙮̀', 'â': '𝙖̂', 'ê': '𝙚̂', 'î': '𝙞̂', 'ô': '𝙤̂', 'û': '𝙪̂', 'ŷ': '𝙮̂', 'ä': '𝙖̈', 'ë': '𝙚̈', 'ï': '𝙞̈', 'ö': '𝙤̈', 'ü': '𝙪̈', 'ÿ': '𝙮̈', 'ã': '𝙖̃', 'ẽ': '𝙚̃', 'ĩ': '𝙞̃', 'õ': '𝙤̃', 'ũ': '𝙪̃', 'ỹ': '𝙮̃', 'å': '𝙖̊', 'ø': '𝙤̊', 'æ': '𝙖𝙚', 'œ': '𝙤𝙚', 'ß': '𝙨𝙨', 'ç': '𝙘̧', 'ñ': '𝙣̃', 'Å': '𝘼̊', 'Ø': '𝙊̊', 'Æ': '𝘼𝙀', 'Œ': '𝙊𝙀', 'Ç': '𝘾̧', 'Ñ': '𝙉̃',
};

// Reverse map for converting back to regular text
const regularMap = {};
for (const key in boldMap) {
    regularMap[boldMap[key]] = key;
}

// Reverse map for converting back to regular text
const regularFromItalicMap = {};
for (const key in italicMap) {
    regularFromItalicMap[italicMap[key]] = key;
}

const regularFromBoldItalicMap = {};
for (const key in boldItalicMap) {
    regularFromBoldItalicMap[boldItalicMap[key]] = key;
}


export function italicize(selectedText) {
    if (!selectedText) return '';

    const allItalic = [...selectedText].every(char => Object.values(italicMap).includes(char) || !/[a-zA-ZÀ-ÿ]/.test(char));

    if (allItalic) {
        // Convert italic → regular
        return [...selectedText].map(char => regularFromItalicMap[char] || char).join('');
    }

    // Convert regular → italic
    return [...selectedText].map(char => italicMap[char] || char).join('');
}

